import { Box, CircularProgress, Divider, Paper, Typography } from "@mui/material"
import React, { useContext, useState } from "react"
import { customPalette } from "../../../../../../../../theme"
import { SquareBadge } from "../../../../../../../components/badges/SquareBadge"
import { IconBuildings } from "../../../../../../../components/custom-icons/icon-buildings"
import { TabEnum } from "../../../../../../../components/tabs/tabs"
import { BSBuildingFormDialog } from "./BSBuildingFormDialog"
import { BSBuildingList } from "./BSBuildingList"
import { BSBuildingListEmpty } from "./BSBuildingListEmpy"
import { BSBuildingListContext } from "./context/BSBuildingListContext"

interface IProps {
  selectedTab: number
  handleSelectTab(index: TabEnum, buildingId?: string): void
}

export function BSBuildingTabMenu({ selectedTab, handleSelectTab }: Readonly<IProps>): React.JSX.Element {
  const { isBSBuildingListLoaded, isBSBuildingListLoading, bsBuildingList } = useContext(BSBuildingListContext)

  const [openCreateBuildingForm, setOpenCreateBuildingForm] = useState<boolean>(false)

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        borderRadius: "14px",
        p: 2,
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.08)",
        overflow: "hidden",
      }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
        }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            color: customPalette.darkBlue3,
            gap: "8px",
          }}>
          <IconBuildings sx={{ color: customPalette.darkBlue3 }} />
          <Typography variant="subtitle2" fontSize={14}>
            Bâtiment
          </Typography>
        </Box>

        {isBSBuildingListLoaded ? (
          <Box>
            <SquareBadge
              content={bsBuildingList?.length ?? 0}
              color={customPalette.lightBlue5}
              backgroundColor={customPalette.lightBlue1}
            />
          </Box>
        ) : (
          <Box>
            <CircularProgress size={16} />
          </Box>
        )}
      </Box>

      <Divider sx={{ mx: -2, color: customPalette.lightBlue4, mb: 2 }} />

      {isBSBuildingListLoading && <CircularProgress />}
      {!isBSBuildingListLoading && (!bsBuildingList || bsBuildingList.length === 0) && (
        <BSBuildingListEmpty setOpenCreateBuildingForm={setOpenCreateBuildingForm} />
      )}
      {!isBSBuildingListLoading && bsBuildingList && bsBuildingList.length > 0 && (
        <BSBuildingList
          selectedTab={selectedTab}
          handleSelectTab={handleSelectTab}
          setOpenCreateBuildingForm={setOpenCreateBuildingForm}
        />
      )}

      <BSBuildingFormDialog open={openCreateBuildingForm} handleClose={() => setOpenCreateBuildingForm(false)} />
    </Paper>
  )
}
